import React from 'react';
import FormElementWrapper from 'components/formElements/FormElementWrapper';
import InputBase, {
  ITextFieldProps as IBaseTextFieldProps
} from 'components/core/Input/Input';
import { IFormElementProps, ComponentWithoutValue } from 'models/form';
import {
  getErrorMessage,
  onChangeFormElementComponent,
  parseErrorMessageToFieldBox
} from 'utilities/form';
import { useForm } from 'react-final-form';

interface ITextFieldProps
  extends ComponentWithoutValue<IBaseTextFieldProps>,
    IFormElementProps {
  inputType?: string;
  hideDeleteButton?: boolean;
}

const Input = ({
  className,
  input,
  meta,
  onChange,
  inputType,
  fieldBoxProps,
  hideDeleteButton,
  ...rest
}: ITextFieldProps) => {
  const form = useForm();
  const handleChange = (value: string): void => {
    onChangeFormElementComponent(
      { value },
      {
        input,
        setModifiedSinceLastBlur: form.mutators.setModifiedSinceLastBlur,
        onChange
      }
    );
  };

  const errorMessage = getErrorMessage(meta);

  return (
    <FormElementWrapper className={className} input={input} meta={meta}>
      <InputBase
        name={input.name}
        value={input.value}
        onChange={handleChange}
        type={inputType}
        hideDeleteButton={hideDeleteButton}
        {...rest}
        fieldBoxProps={{
          ...fieldBoxProps,
          error: parseErrorMessageToFieldBox(errorMessage)
        }}
      />
    </FormElementWrapper>
  );
};

export default Input;
